import React, { FunctionComponent, useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

import {
  Box,
  Grid
} from '@mui/material';

import {
  FileDrop,
  TextInput,
  Typography
} from '../styled';

type ImagePickerProps = {
  sx?: object;
  existing?: string;
  onSelect: (e:File|undefined, f:string|undefined) => void;
  item?: File;
  itemUrl?: string;
  backend?: boolean;
  deleteable?: boolean;
  video?: boolean;
};

export const ImagePicker: FunctionComponent<ImagePickerProps> = ({existing, backend, sx, video, onSelect, item, itemUrl, deleteable}) => {
  const theme = useTheme();
  const {t, i18n} = useTranslation(['translations']);

  const [itemm, setItem] = useState<File|undefined>();
  const [assetUrl, setAssetUrl] = useState<string>();
  const [itemmUrl, setItemUrl] = useState<string|undefined>();
  const [cleared, setCleared] = useState<boolean>(false);

  useEffect(() => {
    setItem(item);
  }, [item]);
  useEffect(() => {
    setItemUrl(itemUrl);
  }, [itemUrl]);
  useEffect(() => {
    if (item !== itemm || itemUrl !== itemmUrl) onSelect(itemm, assetUrl || itemmUrl || undefined);

    if (!!video && !!itemm) {
      var fileInput = document.getElementById('vid_preview');
      var fileUrl = window.URL.createObjectURL(itemm);
      if (!!fileInput) fileInput.setAttribute("src", fileUrl);
      // @ts-ignore
      if (!!fileInput?.parentElement) fileInput?.parentElement?.load();
    }
  }, [itemm, assetUrl, itemmUrl]);

  useEffect(() => {
    if (!!video && !!existing) {
      var fileInput = document.getElementById('vid_preview');
      if (!!fileInput) fileInput.setAttribute("src", existing);
      // @ts-ignore
      if (!!fileInput?.parentElement) fileInput?.parentElement?.load();
    }
  }, [existing, video]);

  return (<Grid container item xs={12} sx={{padding: 0.5, ...(!!backend ? {backgroundColor: 'white'} : {})}}>
    <Grid item xs={3} sx={{paddingBottom: 0.5}}>
      <FileDrop
        acceptedFiles={!!video ? {
          'video/*': [],
        } : {
          'image/jpeg': [],
          'image/png': [],
          'image/jpg': [],
          'image/gif': [],
        }}
        onDrop={acceptedFiles => {setItem(acceptedFiles[0]); setCleared(false);}}
        multiple={false}
        maxFiles={1}
        maxSize={!!video ? (6000 * 1000 * 1000) : (3 * 1000 * 1000)}
        items={!!itemm ? [itemm] : []}
        dropText="Click/Drop"
        dropHint={!!video ? "1 vid, < 6gb" : "All.: 1 img, < 3mb"}
        noPreview
      />
    </Grid>
    <Grid container item xs={6} sx={{paddingLeft: 0.5, paddingRight: 0.5, alignContent: 'baseline'}}>
      <Grid item xs={12}>
        <TextInput
          caption={!!video ? "Video Source URL" : "Image Source URL"}
          value={itemmUrl || ''}
          id="web_url"
          onChange={(v) => {setItemUrl(v); setCleared(false);}}
        />
      </Grid>
      {!!deleteable && <Grid item xs={12}>
        <Typography sx={{
          cursor: 'pointer',
          textDecoration: 'underline',
          color: theme.palette.primary.main,
          fontStyle: 'italic',
          fontSize: '0.8rem'
        }} onClick={() => {
          // console.log('clear image');
          setItem(undefined);
          setItemUrl(undefined);
          setCleared(true);
          onSelect(undefined, undefined);
        }}>{t(!!video ? "general.terms.clear_video" : "general.terms.clear_image", !!video ? "Video verwijderen" : "Afbeelding verwijderen")}</Typography>
      </Grid>}
    </Grid>
    <Grid item xs={3} sx={{paddingBottom: 0.5}}>
      {!video && <Box sx={{
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
        ...(!cleared ? !!item ? {backgroundImage: `url('${URL.createObjectURL(item)}')`} : !!assetUrl ? {backgroundImage: `url('${assetUrl}')`} : !!itemUrl ? {backgroundImage: `url('${itemUrl}')`} : !!existing && !cleared ? {backgroundImage: `url('${existing}')`} : {} : {}),
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat'
      }}></Box>}
      {!!video && <video controls width="125">
        <source src='' id="vid_preview" />
      </video>}
    </Grid>
  </Grid>);
}